<div>
  <div
    class="matrix_layoutMain container matrix_layoutUseMatrix"
    v-bind:class="getClassNameContainer"
  >
    <div class="row">
      <appPageTitle></appPageTitle>
    </div>
    <div class="row">
      <div class="col-md-9 matrix_layoutMatrixContainerColMain">
        <!-- <div class="matrix_layoutHeader">
          <appProductPartsNamesContainer
          ></appProductPartsNamesContainer>
        </div> -->
        <div class="matrix_productPartsMainContainer">
          <appProductParts></appProductParts>
          <appInformation></appInformation>
          <!-- <appBackToMatrixButton></appBackToMatrixButton> -->
          <!-- <appUploadTable></appUploadTable> -->
          <!-- <appPersonalizationButton
            class="matrix_personzalizeButtonMain"
            v-show="getMatrixComplete && getPersonalizationFullPage"
          ></appPersonalizationButton> -->
        </div>
        <!-- <div class="matrix_summaryInformation">
          <appSummaryTable></appSummaryTable>
          <appInformationTable></appInformationTable>
        </div>
        <div class="matrix_summaryInformation">
          <appFactsheet></appFactsheet>
        </div> -->
      </div>
      <div class="col-md-3 matrix_layoutMatrixContainerColSidebar">
        <appCostCenter></appCostCenter>
        <appQuantityTable v-if="!getIsMobile">
          <appQuantityContainer></appQuantityContainer>
          <appInputQuantity></appInputQuantity>
        </appQuantityTable>
        <appSaveCustomizationPopUp></appSaveCustomizationPopUp>
        <!-- <appAddToCartButton
          class="matrix_addToCartButtonMain"
          v-if="getAddToCartFullPage"
        ></appAddToCartButton>
        <appSummarySelectedPageOptions></appSummarySelectedPageOptions>
        <appOtherOptionsTable>
          <appOtherOptionsContainer></appOtherOptionsContainer>
        </appOtherOptionsTable>
        <appOptionsTable>
          <appOptionsContainer></appOptionsContainer>
          <appInputCustomFormatInsert></appInputCustomFormatInsert>
        </appOptionsTable>
        <appUploadTable alwaysShow="true"></appUploadTable>
        <appPersonalizationButton
          class="matrix_personzalizeButtonMobile"
          v-show="getPersonalizationFullPage"
        ></appPersonalizationButton>
        <appAddToCartButton
          class="matrix_addToCartButtonMobile"
          v-if="getAddToCartFullPage"
        ></appAddToCartButton>
        <appQuotationButton></appQuotationButton> -->
        <div v-if="getIsMobile" class="matrix_productPartsMainContainer">
          <appProductParts></appProductParts>
          <appInformation></appInformation>
          <!-- <appBackToMatrixButton></appBackToMatrixButton> -->
        </div>
        <appQuantityTable v-if="getIsMobile">
          <appQuantityContainer></appQuantityContainer>
          <appInputQuantity></appInputQuantity>
        </appQuantityTable>
      </div>
    </div>
    <div class="row">
      <div class="matrix_layoutMatrixContainerUpload">
        <div class="flex flex-column">
          <appUploadContainer alwaysShow="true"></appUploadContainer>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="matrix_layoutPersonalizationButtonContainer">
        <appPersonalizationButton
          class="matrix_personzalizeButtonMain"
          v-show="getPersonalizationFullPage"
        ></appPersonalizationButton>
      </div>
    </div>
    <div class="row">
      <div class="matrix_uploadContainerInfoText">
        <span style="color: #B72E4B;">{{ $t('Please note: ') }}</span>
        <span>{{ $t('You can add your product to your basket with artwork faults before, then discuss options and next steps with our helpful customer services team') }}</span>
      </div>
    </div>
  </div>
  <div class="matrix_summaryFooterContainer">
    <appSummaryFooter></appSummaryFooter>
  </div>
</div>
